module.exports = __webpack_public_path__ + "static/media/term.608b04f5.svg";